import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider.tsx'

export function DashboardPage(): ReactNode {
  const { user } = useAuth()
  if (user === null || user === undefined) return null

  return (
    <div>
      <h1>Selamat datang, {user.fullName}</h1>
      <p className="hint">
        Peran dan penggantian kata sandi ada di <Link to="/profil">Profil</Link>.
      </p>
      <p className="hint">
        Modul data induk, TUK, dan perangkat menyusul pada minggu-minggu berikut Wave 1.
      </p>
    </div>
  )
}
